import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;
export const API = `${BASE}/api`;

export const api = axios.create({
  baseURL: API,
});

// Fallback for browsers/contexts blocking third-party cookies.
api.interceptors.request.use((config) => {
  const t = localStorage.getItem("balboa_token");
  if (t) config.headers["X-Session-Token"] = t;
  return config;
});

export function errMsg(e) {  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || "").join(" ");
  return e?.message || "Something went wrong.";
}

// First-party page-view ping for the admin booking funnel. Anonymous:
// a random id in localStorage, no cookies, no IP stored.
function visitorId() {
  try {
    let v = localStorage.getItem("balboa_vid");
    if (!v) {
      v = (crypto.randomUUID?.() || String(Math.random()).slice(2)).replace(/-/g, "").slice(0, 24);
      localStorage.setItem("balboa_vid", v);
    }
    return v;
  } catch {
    return "";
  }
}

export function trackView(path) {
  api.post("/track", { path, visitor: visitorId() }).catch(() => {});
}

// Cloudinary delivery helpers. Inserts f_auto (WebP/AVIF where supported) +
// q_auto + a width cap into the delivery URL so we never ship the raw original.
export function cld(url, w = 900) {
  if (!url || !url.includes("res.cloudinary.com") || !url.includes("/upload/")) return url;
  const [head, tail] = url.split("/upload/");
  if (/^(f_|q_|w_|c_|dpr_)/.test(tail)) return url; // already transformed
  return `${head}/upload/f_auto,q_auto,w_${w}/${tail}`;
}

export function cldSrcSet(url, widths = [600, 900, 1400]) {
  if (!url || !url.includes("res.cloudinary.com")) return undefined;
  return widths.map((w) => `${cld(url, w)} ${w}w`).join(", ");
}

export const IMG_SIZES = "(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 1400px";

export const GEAR_CATEGORIES = [
  "Microphones",
  "Pres",
  "Dynamics",
  "EQ",
  "Effects",
  "Guitars & Basses",
  "Amps",
  "Drums",
  "Keys & Synth",
  "Recording Setup",
];
